"use client";
import dynamic from "next/dynamic";
import PopupStoreItems from "../../components/AdminForms/PopupStoreItems";
import TitleWithBorder from "../../components/TitleWithBorder";
import useMobileDetect from "../../hooks/useMobileDetect";
import useEffectPromise from "../../hooks/usePromise";
import { StoreService } from "../../services/StoreService";
import { defaultTheme } from "../../styles/defaultTheme";
import {
  Banner,
  FlexCoulmn,
  NextBannerWidthPic,
  PageWrapper
} from "../../styles/globalsStyles";
import { ItemsWrap } from "../../styles/popupStore.style";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useCallback } from "react";
const NoOpenedStore = dynamic(() => import("../../components/NoOpenedStore"));

const PopupStorePage = () => {
  const isMobile = useMobileDetect();
  const getOpenedStore = useCallback(
    () => new StoreService().getOpenedStore(),
    []
  );

  const res = useEffectPromise(getOpenedStore);

  if (!res) return <LoadingSpinner isGlobal />;
  if (!res.openedStore) return <NoOpenedStore />;
  const { openedStore } = res;

  return (
    <PageWrapper>
      <>
        <Banner>
          <FlexCoulmn $gap={"1rem"}>
            <TitleWithBorder
              text={openedStore.name}
              fill={defaultTheme.tertiaryColor}
              width={300}
            />
            {openedStore.img && (
              <NextBannerWidthPic
                src={openedStore.img}
                alt="popup store"
                width={isMobile ? 200 : 650}
                height={isMobile ? 300 : 500}
              />
            )}
          </FlexCoulmn>
        </Banner>

        <ItemsWrap>
          <PopupStoreItems items={openedStore.items} />
        </ItemsWrap>
      </>
    </PageWrapper>
  );
};

export default PopupStorePage;
